export function escapeRegExp(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
}

const NESTED_QUANTIFIER = /(\+|\*|\{\d+(,\d*)?\})\??\)\s*(\+|\*|\{\d+(,\d*)?\})/

export function safeRegExp(pattern, flags) {
    if (!pattern || pattern.length > 200) return null
    if (NESTED_QUANTIFIER.test(pattern)) return null
    try {
        return new RegExp(pattern, flags) // eslint-disable-line security/detect-non-literal-regexp
    } catch {
        return null
    }
}
